module.exports = __webpack_public_path__ + "3b5cb411aa504708ae9e26bc76252a80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img/iphone-bg.png
// module id = 248
// module chunks = 1